const capacityUtilizationCategories = {
    total: {},
    booked: {},
    untilFurtherBooked: {},
    businessBooked: {},
    roundReportDeviation: {},
    subscriptionBookingMissingPaymentEndUnconfirmed: {}
};

Object.keys(capacityUtilizationCategories).forEach(key => {
    capacityUtilizationCategories[key].key = key;
});

export default capacityUtilizationCategories;
